<!--
@create date 2024-5-14
@desc Mask-微信、企业微信打开时的遮罩层组件
-->

<template>
  <div class="maskTipsPage" v-show="showMask">
    <img class="arrowing" :src="arrowing" alt="" />
    <div class="conterBox">
      <p>1，Click on the upper right corner "..."</p>
      <p>2，Select "Open in browser"</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "WechatMask",
  data() {
    return {
      arrowing: require("@/assets/arrowing.png"),
      showMask: false,
    };
  },
  mounted() {
    this.checkDevice(); //检验设备，是否在微信、企业微信打开
  },
  methods: {
    checkDevice() {
      const ua = navigator.userAgent.toLowerCase();
      const isWinxin = ua.indexOf("micromessenger") != -1;
      this.showMask = isWinxin;
    },
  },
};
</script>

<style scoped lang="less">
.maskTipsPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(4, 4, 15, 1);
  opacity: 1;
  .arrowing {
    position: absolute;
    top: 20px;
    right: 10px;
    width: 129px;
    height: 177px;
  }
  .conterBox {
    width: 85%;
    font-size: 18px;
    margin: 30px auto;
    margin-top: 200px;
    color: #ffe75e;
    border: 2px solid #ffe75e;
    padding-left: 12px;
    box-sizing: border-box;
    p {
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WechatMask.vue